import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';

import { IconComponent } from '@shared/components/icon/icon.component';
import { ROUTING_PATH } from '@shared/constants/routingPath';
import { AuthQuery } from '@shared/store/auth/auth.query';
import { WorkflowQuery } from '@shared/store/workflow/workflow.query';
import { WorkflowService } from '@shared/store/workflow/workflow.service';

import { WorkflowPanelGeneralItemComponent } from './workflow-panel-general-item/workflow-panel-general-item.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, IconComponent, RouterLink, WorkflowPanelGeneralItemComponent],
  selector: 'aux-workflow-panel',
  templateUrl: './workflow-panel.component.html',
})
export class WorkflowPanelComponent {
  authQuery = inject(AuthQuery);
  workflowQuery = inject(WorkflowQuery);
  workflowService = inject(WorkflowService);

  isLoading = toSignal(this.workflowQuery.selectLoading(), { requireSync: true });

  workflowName = input.required<string>();

  locked = computed(() => {
    const workflow = this.workflowQuery.getWorkflowByStepType(this.workflowName());

    return workflow()?.properties?.locked || false;
  });

  className = input<string>('');
  hasUserPermissions = input<boolean>(false);
  processing = input<boolean | null>(false);

  quarterCloseChecklistLink = `/${ROUTING_PATH.CLOSING.INDEX}/${ROUTING_PATH.CLOSING.CHECKLIST}`;

  constructor() {
    this.workflowService.getWorkflowList().pipe(takeUntilDestroyed()).subscribe();
  }
}
